import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrderRequestActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { OrderRequestEffectsService } from './order-request.effect.service';
import { OrderRequestPage } from '../order-requet.state';

@Injectable()

export class OrderRequestEffects {

    constructor(
        private actions$: Actions,
        private readonly apiService: ApiService,
        private globalService: GlobalService,
        private orderRequestEffectsService: OrderRequestEffectsService
    ) { }

    fetchOrderRequest$: Observable<
        ReturnType<typeof OrderRequestActions.fetchOrderRequestSuccess> |
        ReturnType<typeof OrderRequestActions.fetchOrderRequestFail>
    > = createEffect(() =>
        this.actions$.pipe(
            ofType(OrderRequestActions.fetchOrderRequest),
            switchMap((action) => {
                this.globalService.loadingSubject.next(true);
                return this.apiService.getOrderRequestList(action.queryText).pipe(
                    map((data: OrderRequestPage) => {
                        this.globalService.loadingSubject.next(false);
                        return OrderRequestActions.fetchOrderRequestSuccess(
                            this.orderRequestEffectsService.formatOrderRequestData(data)
                        );
                    }),
                    catchError((error) => {
                        this.globalService.loadingSubject.next(false);
                        return of(OrderRequestActions.fetchOrderRequestFail({ payload: error }));
                    })
                );
            })
        )
    );

}